import {createAction, props} from '@ngrx/store';


export class CancelFakturierungsbelegDialogActions {

    public static open = createAction(
      '[Fakturierungsbeleg Table] Open cancel fakturierungsbeleg dialog.',
      props<{
        betriebId: string;
        belegId: string;
      }>(),
    );

    public static close = createAction(
      '[Cancel Fakturierungsbeleg Dialog] Close cancel fakturierungsbeleg dialog.',
    );
}
